import FxxlCore from '@fxxl/core';
import FxxlError from '@fxxl/error';
import {addABTastyToHeader, fxxl_CMT_allowed_list, addCriteoToHeader, getCcm} from '@fxxl/globals';
import FxxlShopSuggestion   from '@fxxl/shop_suggestion';

export default class FxxlCmt {
    constructor() {
        this.cmtRootElement = null;
        this.activateClass = 'ccm-root--active';
        this.cmtRootElementSelector = '.ccm-root';
        this.intervalCounter = 0;
        this.isRootActive = false;
        this.rootAllowedToActivate = false;
        this.storagePrefix = 'fxxl_CMT_';
        this.timeoutObject = null;
        this.shopSuggestionInitialized = false;
        this.init();
    }

    init() {
        FxxlCore.removeStoragesWithPrefix(this.storagePrefix);
        this.setEvents();
    }

    setRootElement() {
        this.cmtRootElement = document.querySelector(this.cmtRootElementSelector);
    }

    activatePopup() {
        this.setRootElement();
        if (this.cmtRootElement && !this.isRootActive && this.rootAllowedToActivate) {
            this.isRootActive = true;
            this.cmtRootElement.classList.add(this.activateClass);
        }
    }

    controlAcceptedEmbedding() {
        fxxl_CMT_allowed_list?.forEach((data) => {
            const acceptedEmbedding = data?.name;
            if (acceptedEmbedding) {
                FxxlCore.setStorage(this.storagePrefix + acceptedEmbedding, true);
            }
        });
        this.verifyAndInitialize();
    }

    verifyAndInitialize() {
        const abTastyAccepted = FxxlCore.getStorage(this.storagePrefix + 'ABTasty');
        const criteoAccepted = FxxlCore.getStorage(this.storagePrefix + 'Criteo');
        const emarsysAccepted = FxxlCore.getStorage(this.storagePrefix + 'Emarsys');

        if (abTastyAccepted) {
            addABTastyToHeader();
        }
        if (criteoAccepted) {
            addCriteoToHeader();
        }

        if (emarsysAccepted) {
            FxxlCore.setStorage(FxxlCore.getConfig()?.storageKeys.cmt, true);
        }
    }

    initShopSuggestion() {
        if (
            !FxxlCore.getConfig().server?.presence?.variables?.CONSENT_BANNER_CMT_ENABLED
            || !this.rootAllowedToActivate
            || this.shopSuggestionInitialized
            || !getCcm()?.consent
            || document.querySelector('.ccm-root .ccm-modal.ccm-show')
        ) {
            return;
        }

        // CCM19 kann mehrere Events auslösen, bevor der GeoIP-Request abgeschlossen ist.
        this.shopSuggestionInitialized = true;
        if (!FxxlShopSuggestion.isSetStorageSelectedSuggestedCountry()) {
            const device = FxxlCore.isLargeViewport() ? 'desktop' : 'mobile';
            new FxxlShopSuggestion(device);
        }
    }

    setEvents() {
        window.addEventListener(FxxlCore.getConfig().eventNames.firstActionCached, () => {
            this.rootAllowedToActivate = true;
            this.activatePopup();
            if (fxxl_CMT_allowed_list && fxxl_CMT_allowed_list.length > 0) {
                this.controlAcceptedEmbedding();
            }
            this.initShopSuggestion();
        }, { once: true });

        window.addEventListener('ccm19WidgetLoaded', (data) => {
            this.activatePopup();
            this.initShopSuggestion();
        }, { once: true });

        // Wird auch nach "Alle ablehnen" ausgelöst, ohne optionale Einbindungen.
        window.addEventListener('ccm19WidgetClosed', () => {
            this.initShopSuggestion();
        });

        window.addEventListener('ccm19EmbeddingAccepted', (data) => {
            clearTimeout(this.timeoutObject);
            if (this.rootAllowedToActivate === true) {
                this.timeoutObject = setTimeout(() => {
                    this.controlAcceptedEmbedding();
                }, 100);
            }
        });
    }
}
